<template>
  <div>
    <div class="vfc-multiple-input" :class="{ 'vfc-dark': fConfigs.isDark }" v-if="fConfigs.isModal && fConfigs.isDateRange">
      <slot name="dateRangeInputs" :startDate="dateRangeSelectedStartDate" :endDate="dateRangeSelectedEndDate" :isTypeable="fConfigs.isTypeable">
        <input
          type="text"
          title="Start Date"
          :value="dateRangeSelectedStartDate"
          @input="dateRangeSelectedStartDate = $event.target.value"
          :placeholder="fConfigs.placeholder.split(' ')[0]"
          :readonly="!fConfigs.isTypeable"
          :maxlength="fConfigs.dateFormat.length"
        />
        <input
          type="text"
          title="End Date"
          :value="dateRangeSelectedEndDate"
          @input="dateRangeSelectedEndDate = $event.target.value"
          :placeholder="fConfigs.placeholder.split(' ')[0]"
          :readonly="!fConfigs.isTypeable"
          :maxlength="fConfigs.dateFormat.length"
        />
      </slot>
    </div>
    <div :class="{ 'vfc-dark': fConfigs.isDark }" v-else-if="fConfigs.isModal && fConfigs.isDatePicker">
      <slot name="datePickerInput" :selectedDate="singleSelectedDate" :isTypeable="fConfigs.isTypeable">
        <input
          class="vfc-single-input"
          type="text"
          title="Date"
          :value="singleSelectedDate"
          @input="$emit('update:singleSelectedDate', $event.target.value)"
          :placeholder="fConfigs.placeholder"
          :readonly="!fConfigs.isTypeable"
          :maxlength="fConfigs.dateFormat.length"
        />
      </slot>
    </div>
    <div v-else-if="fConfigs.isModal && fConfigs.isMultipleDatePicker" class="vfc-tags-input-root" :class="{ 'vfc-dark': fConfigs.isDark }">
      <slot name="dateMultiInputs" :selectedDates="calendar.selectedDates" :isTypeable="fConfigs.isTypeable">
        <div class="w-full cursor-pointer bg-white border border-gray-200 rounded p-2 flex items-center h-10">
          <calendar-icon size="1.5x" class="text-gray-600" />
          <div v-if="calendar.selectedDates.length > 0" class="flex">
            <div class="flex text-base text-gray-700 font-normal" v-for="(date, index) in calendar.selectedDates" :key="index">
              <span>{{ date.date }}</span>
              <span class="mr-1" v-if="index + 1 < calendar.selectedDates.length">,</span>
            </div>
          </div>
          <!-- <div v-else class="text-base font-normal text-gray-400">Dates</div> -->
          <div v-else class="text-base font-normal text-gray-400">{{ fConfigs.placeholder.length > 0 ? fConfigs.placeholder : 'Date Range' }}</div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import { default as FeatherIcons } from '../../../feather-icons-wrapper'
const { CalendarIcon } = FeatherIcons

export default {
  name: 'PickerInputs',
  components: {
    CalendarIcon
  },
  props: {
    fConfigs: {
      type: Object,
      required: true
    },
    singleSelectedDate: {
      type: String,
      required: true
    },
    calendar: {
      type: Object,
      required: true
    }
  },
  emits: ['update:singleSelectedDate'],
  data() {
    return {}
  },
  computed: {
    dateRangeSelectedStartDate: {
      get() {
        return this.calendar.dateRange.start ? this.calendar.dateRange.start : ''
      },
      set(newValue) {
        newValue = this.helpCalendar.mask(newValue)
        if (this.helpCalendar.getDateFromFormat(newValue).getMonth()) {
          this.calendar.dateRange.start = newValue
        }
      }
    },
    dateRangeSelectedEndDate: {
      get() {
        return this.calendar.dateRange.end ? this.calendar.dateRange.end : ''
      },
      set(newValue) {
        newValue = this.helpCalendar.mask(newValue)
        if (this.helpCalendar.getDateFromFormat(newValue).getMonth()) {
          this.calendar.dateRange.end = newValue
        }
      }
    }
  }
}
</script>

<style scoped></style>
